type PersonalizationTag = 'member' | 'non-member'
export type PersonalizationTags = PersonalizationTag[] | undefined

export function personalizationControl(personalizationTags: PersonalizationTags) {
  const userStore = useUserStore()

  const { isPreviewEnabled } = useContentfulPreview()
  if (isPreviewEnabled) return true

  if (!Array.isArray(personalizationTags)) return true

  if (
    (!personalizationTags?.includes('non-member') && !userStore.isLoggedIn) ||
    (!personalizationTags?.includes('member') && userStore.isLoggedIn)
  ) {
    return false
  }

  return true
}
